export default {
  FETCH_USER_START: 'FETCH_USER_START',
  FETCH_USER_SUCCESS: 'FETCH_USER_SUCCESS',
  FETCH_USER_FAILURE: 'FETCH_USER_FAILURE',
  ALTER_USER_START: 'ALTER_USER_START',
  ALTER_USER_SUCCESS: 'ALTER_USER_SUCCESS',
  ALTER_USER_FAILURE: 'ALTER_USER_FAILURE',
  UPDATE_USER_START: 'UPDATE_USER_START',
  UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
  UPDATE_USER_FAILURE: 'UPDATE_USER_FAILURE',
  UPDATE_AVATAR_START: 'UPDATE_AVATAR_START',
  UPDATE_AVATAR_SUCCESS: 'UPDATE_AVATAR_SUCCESS',
  UPDATE_AVATAR_FAILURE: 'UPDATE_AVATAR_FAILURE',
}
